import FaqEmpty from './FaqEmpty.component';

export default FaqEmpty;